import { render, staticRenderFns } from "./ColaboradorResponsavel.vue?vue&type=template&id=4029f35b&"
import script from "./ColaboradorResponsavel.vue?vue&type=script&lang=js&"
export * from "./ColaboradorResponsavel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports